<template>
  <div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full">
        <vx-card class="mb-4" :style="`background: #${classroomData.color}`">
          <div class="flex justify-between items-center">
            <h1 class="font-bold">Assignments</h1>
            <vs-button
              color="white"
              :style="`color: #${classroomData.color}`"
              icon-pack="feather"
              icon="icon-plus"
              class="font-bold"
              @click="assignmentCreateToggle"
              >Create New Assignment</vs-button
            >
          </div>
        </vx-card>

        <h2 class="mb-2 font-light">Due Today</h2>
        <div class="grid grid-cols-4 gap-4">
          <classroom-assignment-card
            :item="{
              name: 'Security+ Lab 1',
              percent: 100,
              due: 2,
              thumbnail:
                'https://cdn.discordapp.com/attachments/965812469392101486/972228070075408434/photo-1618005182384-a83a8bd57fbe.avif',
            }"
          />
        </div>

        <h2 class="mb-2 font-light">Due This Week</h2>
        <div class="grid grid-cols-4 gap-4">
          <classroom-assignment-card
            :item="{
              name: 'Security+ Lab 2',
              percent: 56,
              due: 9,
              thumbnail:
                'https://images.unsplash.com/photo-1620121478247-ec786b9be2fa?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1332&q=80f',
            }"
          />
          <classroom-assignment-card
            :item="{
              name: 'Security+ Quiz',
              percent: 45,
              due: 12,
              thumbnail:
                'https://images.unsplash.com/photo-1618556450991-2f1af64e8191?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1064&q=80',
            }"
          />
        </div>

        <h2 class="mb-2 font-light">Due Later On</h2>
        <div class="grid grid-cols-4 gap-4">
          <classroom-assignment-card
            :item="{
              name: 'Security+ Lab 3',
              percent: 0,
              due: 23,
              thumbnail:
                'https://images.unsplash.com/photo-1618004912476-29818d81ae2e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1064&q=80',
            }"
          />
          <classroom-assignment-card
            :item="{
              name: 'Security+ Lab 4',
              percent: 0,
              due: 25,
              thumbnail:
                'https://images.unsplash.com/photo-1617791160530-fb48acfc1658?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1064&q=80',
            }"
          />
          <classroom-assignment-card
            :item="{
              name: 'Security+ Lab 5',
              percent: 0,
              due: 27,
              thumbnail:
                'https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80',
            }"
          />
          <classroom-assignment-card
            :item="{
              name: 'Security+ Exam',
              percent: 0,
              due: 31,
              thumbnail:
                'https://images.unsplash.com/photo-1618556450994-a6a128ef0d9d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1064&q=80',
            }"
          />
        </div>
      </div>
    </div>

    <vs-popup :active.sync="createAssignmentPopup" title="Create New Assignment" class="form-wizard-reduced-padding">
      <form-wizard :subtitle="null" :title="null" color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)">
        <tab-content :before-change="validateStep">
          <vx-card>
            <h2 class="mb-1 font-bold">Create Assignment</h2>
            <p class="mb-2">Lets Start By Entering The Assignments Name.</p>

            <vs-input v-model="createAssignmentValues.title" class="w-full" />
          </vx-card>
        </tab-content>

        <tab-content :before-change="validateStep">
          <vx-card class="mb-2">
            <h2 class="mb-2 font-bold">Assignment Details</h2>
            <quill-editor class="" style="min-height: 175px" v-model="createAssignmentValues.post" :options="editorOption" />
          </vx-card>
        </tab-content>

        <tab-content :before-change="validateStep">
          <vx-card>
            <h2 class="mb-3 font-bold">Assignment Starting Date</h2>
            <datepicker
              v-model="createAssignmentValues.start_at"
              :inline="true"
              class="datepicker-popup-inline mb-4"
              placeholder="Select Date"
            ></datepicker>

            <div class="flex items-center">
              <feather-icon icon="InfoIcon" svgClasses="h-6 w-6 mr-1" />
              <h5 class="ml-1 font-light">The assignment will become visible on this date</h5>
            </div>
          </vx-card>
        </tab-content>

        <tab-content :before-change="validateStep">
          <vx-card>
            <h2 class="mb-3 font-bold">Assignment Due Date</h2>
            <datepicker
              v-model="createAssignmentValues.due_at"
              :inline="true"
              class="datepicker-popup-inline mb-4"
              placeholder="Select Date"
            ></datepicker>

            <div class="flex items-center">
              <feather-icon icon="InfoIcon" svgClasses="h-6 w-6 mr-1" />
              <h5 class="ml-1 font-light">The assignment will become due on this date</h5>
            </div>
          </vx-card>
        </tab-content>

        <tab-content :before-change="validateStep">
          <div>
            <vx-card class="mb-3">
              <div class="flex items-center justify-between mb-3">
                <h2 class="font-bold">Assignment Tasks</h2>
                <vs-button icon-pack="feather" icon="icon-plus" class="font-bold" @click="taskCreateInit">Create Task</vs-button>
              </div>
            </vx-card>

            <div class="">
              <vx-card class="mb-3" v-for="(task, index) in createAssignmentTasks" :key="index">
                <div class="flex justify-between items-center">
                  <div class="flex items-center">
                    <img alt="" :src="task.details.thumbnail" v-if="task.details.thumbnail" width="50" class="rounded-lg mr-3" />
                    <div>
                      <h3 class="font-semibold">{{ task.details.name }}</h3>
                      <h6 class="font-light">{{ taskModuleText(task.module) }} {{ task.type | capitalize }}</h6>
                    </div>
                  </div>
                  <feather-icon
                    icon="TrashIcon"
                    @click="createAssignmentTasks.splice(index, 1)"
                    svgClasses="w-8 h-8 text-danger cursor-pointer"
                  />
                </div>
              </vx-card>
            </div>
          </div>
        </tab-content>

        <tab-content icon="feather icon-check"> </tab-content>
      </form-wizard>
    </vs-popup>
    <vs-popup :active.sync="createTaskPopup" title="Create New Task" class="form-wizard-reduced-padding">
      <div class="p-2">
        <div v-if="createTaskStep === 0">
          <h2 class="mb-2 font-bold">Select Module</h2>

          <div class="grid grid-cols-2 gap-4">
            <vx-card class="cursor-pointer" @click="taskCompleteStep(0, 'simulation')">
              <div class="flex justify-center items-center">
                <feather-icon icon="CodesandboxIcon" svgClasses="h-8 w-8 mr-1" />
                <h1 class="font-light ml-1">Simulation</h1>
              </div>
            </vx-card>
            <vx-card class="cursor-pointer" @click="taskCompleteStep(0, 'flashcard')">
              <div class="flex justify-center items-center">
                <feather-icon icon="FileTextIcon" svgClasses="h-8 w-8 mr-1" />
                <h1 class="font-light ml-1">FlashCard</h1>
              </div>
            </vx-card>
          </div>
        </div>

        <div v-if="createTaskStep === 1">
          <h2 class="mb-2 font-bold">Select Type</h2>

          <div class="grid grid-cols-1 gap-4">
            <vx-card class="cursor-pointer" @click="taskCompleteStep(1, 'completion')">
              <div class="flex justify-center items-center">
                <feather-icon icon="CheckCircleIcon" svgClasses="h-8 w-8 mr-1" />
                <h1 class="font-light ml-1">Completion</h1>
              </div>
            </vx-card>
          </div>
        </div>

        <div v-if="createTaskStep === 2">
          <h2 class="mb-2 font-bold">Set Simulation Requirements</h2>

          <div class="grid grid-cols-2 gap-4 mb-2">
            <div class="vx-card p-3">
              <h5 class="font-bold mb-2">Module</h5>
              <div class="flex items-center" v-if="createTaskValue.module === 'simulation'">
                <feather-icon icon="CodesandboxIcon" svgClasses="h-6 w-6 mr-1" />
                <h4 class="font-light ml-1">Simulation</h4>
              </div>
              <div class="flex items-center" v-if="createTaskValue.module === 'flashcard'">
                <feather-icon icon="FileTextIcon" svgClasses="h-6 w-6 mr-1" />
                <h4 class="font-light ml-1">FlashCard</h4>
              </div>
            </div>
            <div class="vx-card p-3">
              <h5 class="font-bold mb-2">Type</h5>
              <div class="flex items-center" v-if="createTaskValue.type === 'completion'">
                <feather-icon icon="CheckCircleIcon" svgClasses="h-6 w-6 mr-1" />
                <h4 class="font-light ml-1">Completion</h4>
              </div>
            </div>
          </div>

          <div class="vx-card mb-2 p-3" v-if="createTaskSimulation">
            <div class="flex justify-between items-center">
              <div>
                <h5 class="font-bold mb-2">Assigned Simulation</h5>
                <div class="flex items-center" v-if="createTaskValue.type === 'completion'">
                  <img
                    v-if="createTaskSimulation.thumbnail"
                    :src="createTaskSimulation.thumbnail"
                    width="35"
                    alt=""
                    class="mr-2 rounded-lg"
                  />
                  <h4 class="font-light">{{ createTaskSimulation.name }}</h4>
                </div>
              </div>
              <vs-button type="gradient" icon-pack="feather" icon="icon-edit" @click="simulationSelectActive = !simulationSelectActive"
                >Change
              </vs-button>
            </div>
          </div>

          <div class="vx-card mb-2 p-3" v-if="createTaskFlashcardSet">
            <div class="flex justify-between items-center">
              <div>
                <h5 class="font-bold mb-2">Assigned FlashCard</h5>
                <div class="flex items-center" v-if="createTaskValue.type === 'completion'">
                  <img v-if="createTaskFlashcardSet.icon" :src="createTaskFlashcardSet.icon" width="35" alt="" class="mr-2 rounded-lg" />
                  <h4 class="font-light">{{ createTaskFlashcardSet.name }}</h4>
                </div>
              </div>
              <vs-button type="gradient" icon-pack="feather" icon="icon-edit" @click="flashcardSetSelectActive = !flashcardSetSelectActive"
                >Change
              </vs-button>
            </div>
          </div>
          <vs-table
            v-if="simulationSelectActive && createTaskValue.module === 'simulation'"
            :data="simulationSelectResults"
            :sst="true"
            max-items="5"
            class="mb-2"
            search
            @search="fetchSimulations"
          >
            <template slot="header">
              <h3 class="ml-4">Simulations</h3>
            </template>

            <template slot="thead">
              <vs-th>Name</vs-th>
              <vs-th>Type</vs-th>
              <vs-th>Action</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr v-for="attach in data" :key="attach.id">
                <vs-td :data="`${attach.name}`">
                  <div class="flex align-middle items-center">
                    <img :src="attach.thumbnail" class="rounded mr-3" width="40px" alt="" />
                    {{ `${attach.name}` }}
                  </div>
                </vs-td>

                <vs-td :data="attach.type">
                  {{ attach.type | capitalize }}
                </vs-td>

                <vs-td>
                  <vs-button
                    color="danger"
                    size="small"
                    type="border"
                    icon-pack="feather"
                    icon="icon-x-circle"
                    class="w-full"
                    @click="
                      createTaskSimulation = null;
                      simulationSelectActive = true;
                    "
                    v-if="createTaskSimulation && createTaskSimulation.id === attach.id"
                  >
                    Remove
                  </vs-button>
                  <vs-button
                    color="primary"
                    size="small"
                    type="border"
                    icon-pack="feather"
                    icon="icon-check-circle"
                    class="w-full"
                    @click="
                      createTaskSimulation = attach;
                      simulationSelectActive = false;
                    "
                    v-else
                  >
                    Assign
                  </vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <vs-table
            v-if="flashcardSetSelectActive && createTaskValue.module === 'flashcard'"
            :data="flashcardSelectSetResults"
            :sst="true"
            max-items="5"
            class="mb-2"
            search
            @search="fetchFlashcardSets"
          >
            <template slot="header">
              <h3 class="ml-4">FlashCard Sets</h3>
            </template>

            <template slot="thead">
              <vs-th>Name</vs-th>
              <vs-th>Terms</vs-th>
              <vs-th>Action</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr v-for="attach in data" :key="attach.id">
                <vs-td :data="`${attach.name}`">
                  <div class="flex align-middle items-center">
                    <img :src="attach.icon" class="rounded mr-3" width="40px" alt="" />
                    {{ `${attach.name}` }}
                  </div>
                </vs-td>

                <vs-td :data="attach.terms.length">
                  {{ attach.terms.length }}
                </vs-td>

                <vs-td>
                  <vs-button
                    color="danger"
                    size="small"
                    type="border"
                    icon-pack="feather"
                    icon="icon-x-circle"
                    class="w-full"
                    @click="
                      createTaskFlashcardSet = null;
                      flashcardSetSelectActive = true;
                    "
                    v-if="createTaskFlashcardSet && createTaskFlashcardSet.id === attach.id"
                  >
                    Remove
                  </vs-button>
                  <vs-button
                    color="primary"
                    size="small"
                    type="border"
                    icon-pack="feather"
                    icon="icon-check-circle"
                    class="w-full"
                    @click="
                      createTaskFlashcardSet = attach;
                      flashcardSetSelectActive = false;
                    "
                    v-else
                  >
                    Assign
                  </vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <vs-button type="gradient" class="mt-2" :disabled="!createTaskSimulation && !createTaskFlashcardSet" @click="taskCreateAction">
            Create Task</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import ClassroomMeetingCard from '../components/meeting/ClassroomMeetingCard';
import 'quill/dist/quill.snow.css';
import { quillEditor } from 'vue-quill-editor';
import Datepicker from 'vuejs-datepicker';
import ClassroomAssignmentCard from '../components/assignment/ClassroomAssignmentCard';

export default {
  name: 'ClassroomStreamTab',
  data() {
    return {
      createAssignmentPopup: false,
      createAssignmentValues: {
        title: null,
        post: null,
        start_at: null,
        due_at: null,
      },
      createAssignmentTasks: [],

      createTaskStep: 0,
      createTaskPopup: false,
      createTaskValue: {
        type: null,
        module: null,
      },

      createTaskSimulation: null,
      createTaskFlashcardSet: null,

      simulationSelectActive: true,
      simulationSelectResults: [],

      flashcardSetSelectActive: false,
      flashcardSelectSetResults: [],

      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ script: 'sub' }, { script: 'super' }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ align: [] }],
            [{ color: [] }, { background: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['clean'],
          ],
        },
      },

      currentPage: 1,
      pageSize: 10,
      pagesLoaded: [],

      meetingsActive: {
        count: 0,
        pages: 0,
        data: [],
        loaded: false,
      },
    };
  },
  components: {
    ClassroomMeetingCard,
    quillEditor,
    Datepicker,
    FormWizard,
    TabContent,
    ClassroomAssignmentCard,
  },
  computed: {},
  props: {
    classroomId: {
      type: String,
      required: true,
    },
    classroomData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    assignmentCreateToggle() {
      this.createAssignmentValues = { title: null, post: null, start_at: null, due_at: null };
      this.createAssignmentPopup = !this.createAssignmentPopup;
    },
    fetchInit() {
      this.currentPage = 1;
      this.meetingsActive = { count: 0, pages: 0, data: [], loaded: false };
      this.fetchClassroomAssignments();
    },
    fetchClassroomAssignments() {
      this.$http.get(`app/classroom/${this.classroomId}/meeting?amount=${this.pageSize}&page=${this.currentPage}`).then((response) => {
        if (response.data.data) {
          this.meetingsActive.count = response.data.data.count;
          this.meetingsActive.pages = response.data.data.pages;
          response.data.data.data.forEach((item) => {
            this.meetingsActive.data.push(item);
          });
          this.meetingsActive.loaded = true;
        }
      });
    },
    fetchSimulations(search = '') {
      this.$http.get(`simulations?search=${search}&pageSize=5`).then((response) => {
        if (response.data) {
          this.simulationSelectResults = response.data.data;
        }
      });
    },
    fetchFlashcardSets(search = '') {
      this.$http.get(`flashcards/sets?search=${search}&pageSize=5`).then((response) => {
        if (response.data) {
          this.flashcardSelectSetResults = response.data.data;
        }
      });
    },
    loadMore() {
      this.currentPage++;
      this.fetchClassroomAssignments();
    },
    taskCreateComplete() {
      this.createAssignmentPopup = true;
      this.createTaskPopup = false;
    },
    taskCreateInit() {
      this.createAssignmentPopup = false;
      this.createTaskPopup = true;
      this.createTaskStep = 0;
      this.createTaskValue = { type: null, module: null };
      this.createTaskSimulation = null;
      this.createTaskFlashcardSet = null;
      this.simulationSelectActive = true;
      this.flashcardSetSelectActive = true;
    },
    taskCreateAction() {
      const task = this.createTaskValue;
      if (task.module === 'simulation') {
        task.id = this.createTaskSimulation.id;
        task.details = this.createTaskSimulation;
      }
      if (task.module === 'flashcard') {
        task.id = this.createTaskFlashcardSet.id;
        task.details = this.createTaskFlashcardSet;
      }
      if (this.createAssignmentTasks.filter((item) => item.id === task.id && item.module === task.module).length) {
        this.$vs.notify({
          color: 'danger',
          title: 'Task Already Exists',
          text: 'A task for this simulation already exists',
          position: 'top-right',
        });
      } else {
        this.createAssignmentTasks.push(task);
      }
      this.taskCreateComplete();
    },
    taskCompleteStep(step, value) {
      if (step === 0 && value) {
        this.createTaskStep = 1;
        this.createTaskValue.module = value;
      }
      if (step === 1 && value) {
        this.createTaskStep = 2;
        this.createTaskValue.type = value;
      }
    },
    taskModuleText(module) {
      if (module === 'simulation') return 'Simulation';
      if (module === 'flashcard') return 'FlashCard Set';
      return '';
    },
    validateStep() {
      return new Promise((resolve) => {
        resolve(true);
      });
    },
  },
  mounted() {
    this.fetchInit();
    this.fetchSimulations();
    this.fetchFlashcardSets();
  },
};
</script>

<style lang="scss">
.meeting-cards {
  .vs-collapse {
    padding: 0;
  }

  .vs-collapse-item--header {
    padding: 0;
  }

  .vs-collapse-item--icon-header {
    display: none;
  }

  .vs-collapse.default .open-item .con-content--item {
    padding: 0;
  }
}
</style>
